import FormTranslationContext from "context/FormTranslationContext";
import getObjectValue from "libs/getObjectValue";
import { useContext } from "react";
import NoticeGlossaryInput from "../../components/inputs/NoticeGlossaryInput";

function BasicData(
    {
        id,
        formikProps
    }) {
    const gId = (name) => id + "." + name;
    const updateNotice = getObjectValue('_updateNotice', formikProps.values, true);
    const { getDict } = useContext(FormTranslationContext);
    return (
        <>
        <NoticeGlossaryInput
            id={gId("refersTo")}
            formikProps={formikProps}
            items={getDict("SL.MO.010")}
            required
            disabled={updateNotice}
        />
        </>
    )
}
BasicData.propTypes = {};
export default BasicData;